import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, Palette } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { brand } from "@/lib/api";
import { useSeo } from "@/lib/seo";

export default function Login() {
  useSeo({ title: "Admin Login" });
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin");
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-5" data-testid="login-page">
      <div className="card-pop p-8 max-w-md w-full text-center">
        <img src={brand.logo} alt="Paint With Tay" className="h-20 w-auto mx-auto mb-4" data-testid="brand-logo" />
        <div className="w-14 h-14 mx-auto rounded-full bg-hotpink border-[3px] border-ink flex items-center justify-center mb-4">
          <Palette className="w-7 h-7 text-white" />
        </div>
        <h1 className="font-heading text-3xl font-700 mb-2">Owner Dashboard</h1>
        <p className="text-ink/70 mb-6">Sign in with Google to manage bookings, availability, gallery and content.</p>
        <button onClick={handleLogin} className="btn-pink w-full" data-testid="google-login-btn">
          <LogIn className="w-5 h-5" /> Sign in with Google
        </button>
        {user && !user.is_admin && (
          <p className="mt-4 text-hotpink font-600" data-testid="not-authorized-msg">
            This account isn’t authorized for the admin dashboard.
          </p>
        )}
      </div>
    </div>
  );
}
